<template lang="pug">
  .menu-bonus(ref="menuBonus")
    .menu-bonus-item(@click="sendNotification")
      .menu-bonus-item-text Enviar notificación
    .menu-bonus-item(@click="openNotificationHistory")
      .menu-bonus-item-text Historial de notificaciones
</template>

<script>
export default {
  name: 'MenuBonus',

  props: {
    index: {
      type: Number,
      required: true
    }
  },

  methods: {
    sendNotification () {
      this.$emit('sendNotification')
      this.$store.commit('hideMenu', this.index)
    },

    openNotificationHistory () {
      this.$emit('openNotificationHistory')
      this.$store.commit('hideMenu', this.index)
    }
  }
}
</script>

<style lang="stylus" scoped>
.menu-bonus
  display flex
  flex-direction column
  border-radius 0.5em
  border 1px solid rgba(0,0,0,0.2)
  background-color #ffffff
  position absolute
  z-index 1000
  top 3em

.menu-bonus-item
  padding .5em 1em
  cursor pointer

.menu-bonus-item-text
  white-space nowrap

.menu-bonus-item:hover
  background-color rgba(0,0,0,0.1)
</style>



// WEBPACK FOOTER //
// src/components/pages/bonus/MenuBonus.vue